/**
 * Teams-facing formatting: text normalization for the markdown subset Teams
 * renders, plus Adaptive Card construction for question posts with options.
 */
import type { FormatConverter } from "./types.js";

/**
 * Teams' supported markdown subset pass-through: normalizes constructs Teams
 * cannot render (~~strike~~ → plain, heading # → bold line); everything else
 * verbatim. Line-based on purpose — no markdown parser; fenced code passes
 * through untouched.
 */
export function markdownToTeamsText(markdown: string): string {
  let inFence = false;
  return markdown
    .split("\n")
    .map((line) => {
      if (/^\s*```/.test(line)) {
        inFence = !inFence;
        return line;
      }
      if (inFence) return line;
      const heading = line.match(/^#{1,6}\s+(.*)$/);
      const text = heading ? `**${heading[1]}**` : line;
      return text.replace(/~~(.+?)~~/g, "$1");
    })
    .join("\n");
}

/** Adaptive Card 1.4 JSON for a question with option buttons (Action.Submit, data: { option }). */
export function makeQuestionCard(markdown: string, options: string[]): Record<string, unknown> {
  return {
    type: "AdaptiveCard",
    version: "1.4",
    $schema: "http://adaptivecards.io/schemas/adaptive-card.json",
    body: [{ type: "TextBlock", text: markdownToTeamsText(markdown), wrap: true }],
    actions: options.map((option) => ({
      type: "Action.Submit",
      title: option,
      data: { option },
    })),
  };
}

/** {@link FormatConverter} for adapters whose `textFormat` is `"adaptive-card"` (Teams). */
export const teamsFormatConverter: FormatConverter = { toPlatformText: markdownToTeamsText };
